module.exports = __webpack_public_path__ + "img/symbol_0.33f831e8.png";